import classes from "./contactFieldInput.module.scss";

/**
 * Plain (non-MUI) labeled text input for the searchFlowVersionB contact page.
 * MUI's TextField brings in `.MuiOutlinedInput-*` classnames that legacy global
 * CSS (src/index.css, old searchFlow.scss) already targets with `!important`,
 * so every visual tweak here turned into a specificity fight. A plain input
 * only has to beat the couple of genuinely global element-selector rules
 * (`input { font-weight: 700 !important }`), which `.input` already does.
 */
const ContactFieldInput = ({
  id,
  name,
  label,
  type = "text",
  placeholder,
  value,
  onChange,
  onBlur,
  error,
  errorText,
  disabled,
  className = "",
}) => (
  <div className={`${classes.root} ${className}`.trim()}>
    <label className={classes.label} htmlFor={id}>
      {label}
    </label>
    <input
      id={id}
      name={name}
      type={type}
      className={`${classes.input} ${error ? classes.inputError : ""}`.trim()}
      placeholder={placeholder}
      value={value}
      onChange={onChange}
      onBlur={onBlur}
      disabled={disabled}
      autoComplete="off"
    />
    <p
      className={`${classes.errorText} ${
        error && errorText ? classes.errorTextVisible : ""
      }`.trim()}
    >
      {errorText || " "}
    </p>
  </div>
);

export default ContactFieldInput;
